// extracted by mini-css-extract-plugin
export default {"comment":"Comment_comment__JDZeW","header":"Comment_header__L1JFA","author":"Comment_author__6GQZm","date":"Comment_date__4wSkz","commentText":"Comment_commentText__q1CVx"};